import React from "react"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  useTheme,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { format } from "date-fns"
import { ru } from "date-fns/locale"
import { ChatViewer } from "../interfaces/chatViewer"

interface UserGroupsAccordionProps {
  groups: ChatViewer.UserGroup[]
}

export const UserGroupsAccordion: React.FC<UserGroupsAccordionProps> = ({
  groups,
}) => {
  const theme = useTheme()

  if (!groups || groups.length === 0) {
    return null
  }

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      sx={{
        "&:before": { display: "none" },
        mt: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body2">Группы ({groups.length})</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Название</TableCell>
              <TableCell>Username</TableCell>
              <TableCell>Дата входа</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups.map((group) => (
              <TableRow key={group.group_id}>
                <TableCell>{group.group_title}</TableCell>
                <TableCell>@{group.group_username}</TableCell>
                <TableCell>
                  {format(new Date(group.join_date), "dd.MM.yyyy", {
                    locale: ru,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  )
}
